var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_6566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8918 7.74256L12.3034 1.10939C11.9373 0.740881 11.3883 0.740881 11.0223 1.10939C10.6562 1.4779 10.6562 2.03066 11.0223 2.39917L11.2053 2.58343L5.89789 6.36065L2.96969 6.72916C2.05462 6.91341 1.23106 7.5583 0.956542 8.38745C0.682022 9.21659 0.865035 10.23 1.50558 10.7828L4.70831 14.0072L2.42065 16.3104C2.05462 16.6789 2.05462 17.2317 2.42065 17.6002C2.60366 17.7844 2.87818 17.8766 3.06119 17.8766C3.2442 17.8766 3.51872 17.7844 3.70174 17.6002L5.9894 15.297L9.19213 18.5215C9.64966 18.9821 10.1987 19.1663 10.8392 19.1663C11.1138 19.1663 11.3883 19.1663 11.5713 19.0742C12.4864 18.7978 13.1269 17.9687 13.2184 17.0474L13.6759 14.0993L17.3362 8.84808L17.6107 9.12446C17.7937 9.30872 18.0683 9.40085 18.2513 9.40085C18.4343 9.40085 18.7088 9.30872 18.8918 9.12446C19.2578 8.75596 19.2578 8.11106 18.8918 7.74256Z",
    fill: "#E1E1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_6566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.1eb6278bb954ca4afee5c8daa306e83e.svg";
export { ForwardRef as ReactComponent };